module.exports = __webpack_public_path__ + "img/firstdraft.c0a2aff0.svg";